import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as bootstrap from 'bootstrap'

import IMG_ConcursoBuenasPracticas from '../../assets/img/concurso_buenas_practicas.png'

export default function Navbar() {

    const navigateTo = useNavigate()
    const collapseRef = useRef()
    const collapseBtnRef = useRef()
    const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(false)
    const bsCollapseRef = useRef(null)

    const btnIndexOnClick = () => {
        navigateTo('/home')
    }

    const btnBasesOnClick = () => {
        navigateTo('/competition-rules')
    }

    const btnBuenasPracticasOnClick = () => {
        navigateTo('/good-practices')
    }

    const btnFaqOnClick = () => {
        navigateTo('/faq')
    }

    const btnContactoOnClick = () => {
        navigateTo('/contact-us')
    }

    const btnIngresarOnClick = () => {
        window.open('https://empresa.buenaspracticasensst.cl/sign-on', '_blank')
    }

    const handleNavbarCollapse = () => {
        setIsNavbarCollapsed(!isNavbarCollapsed)
        if (!isNavbarCollapsed) {
            // Opening
            bsCollapseRef.current?.show()
        } else {
            // Closing
            bsCollapseRef.current?.hide()
        }
    }

    useEffect(() => {
        if (!collapseRef.current) return

        const collapseElement = collapseRef.current
        const collapseInstance = new bootstrap.Collapse(collapseElement, {
            toggle: false
        })
        bsCollapseRef.current = collapseInstance

        const handleShow = () => setIsNavbarCollapsed(true)
        const handleHide = () => setIsNavbarCollapsed(false)

        collapseElement.addEventListener('show.bs.collapse', handleShow)
        collapseElement.addEventListener('hide.bs.collapse', handleHide)

        return () => {
            collapseElement.removeEventListener('show.bs.collapse', handleShow)
            collapseElement.removeEventListener('hide.bs.collapse', handleHide)
            collapseInstance.dispose()
            bsCollapseRef.current = null
        }
    }, [])

    return (
        <nav className="navbar navbar-expand-lg bg-good-practice fixed-top py-0 px-lg-0 px-4">
            <div className="container">
                <a className="navbar-brand react-link container-logo" onClick={btnIndexOnClick}>
                    <img
                        src={IMG_ConcursoBuenasPracticas}
                        className="img-fluid"
                        style={{
                            maxWidth: '320px',
                            height: 'auto'
                        }}
                    />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarItem" aria-controls="collapse" aria-expanded="false" aria-label="Toggle navigation"
                    onClick={handleNavbarCollapse}
                    ref={collapseBtnRef}
                    style={{
                        padding: '0.25rem 0.75rem',
                        fontSize: '1.25rem',
                        lineHeight: '1'
                    }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', width: '24px', height: '24px' }}>
                        <path d="M4 6H20M4 12H20M4 18H20" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>
                <div className="navbar-collapse collapse" id="navbarItem" ref={collapseRef}>
                    <ul className="navbar-nav ms-auto mb-4 mb-lg-0 text-end text-lg-start">
                        <li className="nav-item">
                            <a className={`nav-link ${window.location.pathname === '/competition-rules' ? 'active' : ''}`}
                                onClick={() => {
                                    if (isNavbarCollapsed) handleNavbarCollapse()
                                    btnBasesOnClick()
                                }}
                            >Bases</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${window.location.pathname === '/good-practices' ? 'active' : ''}`}
                                onClick={() => {
                                    if (isNavbarCollapsed) handleNavbarCollapse()
                                    btnBuenasPracticasOnClick()
                                }}
                            >Buenas Prácticas</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${window.location.pathname === '/faq' ? 'active' : ''}`}
                                onClick={() => {
                                    if (isNavbarCollapsed) handleNavbarCollapse()
                                    btnFaqOnClick()
                                }}
                            >Preguntas Frecuentes</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${window.location.pathname === '/contact-us' ? 'active' : ''}`}
                                onClick={() => {
                                    if (isNavbarCollapsed) handleNavbarCollapse()
                                    btnContactoOnClick()
                                }}
                            >Contacto</a>
                        </li>
                        <li className="nav-item ms-lg-4 ms-3 mt-lg-0 mt-4">
                            <a className="btn btn-primary btn-2026 d-block rounded-pill px-4 py-0"
                                onClick={() => {
                                    if (isNavbarCollapsed) handleNavbarCollapse()
                                    btnIngresarOnClick()
                                }}
                            >Ingresar</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}
